import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { FaMoneyBillWave, FaChartLine, FaInfinity } from 'react-icons/fa';
import { DotScreenShader } from '../components/DotScreenShader';
import './FeaturesPage.css'; // Reuse existing styles for consistency

export const AffiliatesPage = () => {
    return (
        <div className="App" style={{ position: 'relative' }}>
            <div style={{ position: 'fixed', inset: 0, zIndex: 0 }}>
                <DotScreenShader theme="dark" />
            </div>

            <Navbar />

            <main className="hero" style={{ position: 'relative', zIndex: 1, paddingTop: '100px', minHeight: 'auto', paddingBottom: '20px' }}>
                <p className="hero-preheader hero-preheader--centered">Partner Program</p>
                <h1 className="hero-heading hero-heading--centered">
                    Earn Monthly <span className="text-highlight">Recurring Commissions</span>
                </h1>
                <p className="hero-subheader">
                    Join the CutIQ Affiliate Program and earn 30% recurring commission on every referral.
                    <br />No cap on earnings.
                </p>

                <div className="features-list" style={{ marginTop: '60px', maxWidth: '1100px', width: '100%' }}>
                    <section className="feature-section">
                        <div className="feature-header">
                            <h2 style={{ fontSize: 'clamp(2.5rem, 6vw, 4rem)', fontWeight: 800, textShadow: '0 0 40px rgba(6, 182, 212, 0.2)', textTransform: 'none', letterSpacing: 'normal' }}>Why Partner With Us?</h2>
                            <p className="feature-description">The easiest way to monetize your audience.</p>
                        </div>

                        <div className="ai-features-grid">
                            <div className="ai-feature-card">
                                <div className="ai-feature-header">
                                    <div className="ai-icon">
                                        <FaMoneyBillWave size={24} />
                                    </div>
                                    <h3 style={{ fontSize: '1.75rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>30% Recurring</h3>
                                </div>
                                <div className="ai-tech-badge">Lifetime Commission</div>
                                <p style={{ fontSize: '1.1rem', color: '#a1a1aa' }}>Earn 30% of every payment your referrals make, for the lifetime of their subscription.</p>
                            </div>

                            <div className="ai-feature-card">
                                <div className="ai-feature-header">
                                    <div className="ai-icon">
                                        <FaInfinity size={24} />
                                    </div>
                                    <h3 style={{ fontSize: '1.75rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>No Cap on Earnings</h3>
                                </div>
                                <div className="ai-tech-badge">Unlimited Scale</div>
                                <p style={{ fontSize: '1.1rem', color: '#a1a1aa' }}>The sky is the limit. The more you refer, the more you earn. There is no maximum payout limit.</p>
                            </div>

                            <div className="ai-feature-card">
                                <div className="ai-feature-header">
                                    <div className="ai-icon">
                                        <FaChartLine size={24} />
                                    </div>
                                    <h3 style={{ fontSize: '1.75rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Real-Time Tracking</h3>
                                </div>
                                <div className="ai-tech-badge">Live Dashboard</div>
                                <p style={{ fontSize: '1.1rem', color: '#a1a1aa' }}>Track your clicks, referrals, and commissions in real-time through our dedicated dashboard.</p>
                            </div>
                        </div>
                    </section>
                </div>

                {/* CTA Section */}
                <div className="features-cta" style={{ marginTop: '80px', marginBottom: '80px' }}>
                    <h2 style={{ fontSize: 'clamp(2.5rem, 6vw, 4rem)', fontWeight: 800, textShadow: '0 0 40px rgba(6, 182, 212, 0.2)' }}>Ready to Start Earning?</h2>
                    <p style={{ fontSize: '1.1rem', color: '#a1a1aa', marginTop: '16px' }}>Join hundreds of content creators monetizing their traffic with CutIQ.</p>
                    <div className="cta-buttons" style={{ marginTop: '32px' }}>
                        <a
                            href="https://affiliates.cutiq.ai/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cta-primary"
                        >
                            Become an Affiliate
                        </a>
                    </div>
                </div>
            </main>

            <div style={{ position: 'relative', zIndex: 1, width: '100%' }}>
                <Footer />
            </div>
        </div>
    );
};
